export default function QuickContactBar() {
  return (
    <aside
      aria-label="Hurtig kontakt"
      className="hidden md:flex fixed right-0 top-1/2 -translate-y-1/2 z-40 flex-col shadow-2xl rounded-l-lg overflow-hidden border border-r-0 border-white/20"
    >
      <a
        href="tel:+4570700800"
        title="Ring til Vagtcentral 24/7: +45 70 700 800"
        className="group relative flex items-center justify-center w-12 h-12 bg-red-600 hover:bg-red-700 text-white transition-colors"
      >
        <i className="fa-solid fa-phone text-lg" aria-hidden="true" />
        <span className="sr-only">Ring til vagtcentral 24/7 på +45 70 700 800</span>
        <span className="pointer-events-none absolute right-full mr-2 hidden group-hover:flex items-center whitespace-nowrap bg-zinc-900 text-white text-xs font-semibold px-3 py-1.5 rounded shadow-lg">
          Vagtcentral 24/7: +45 70 700 800
        </span>
      </a>

      <a
        href="mailto:kontor@mcautotransport.dk"
        title="Send e-mail til kontor@mcautotransport.dk"
        className="group relative flex items-center justify-center w-12 h-12 bg-zinc-900 hover:bg-zinc-800 text-white transition-colors border-t border-white/10"
      >
        <i className="fa-solid fa-envelope text-lg" aria-hidden="true" />
        <span className="sr-only">Send mail til kontor@mcautotransport.dk</span>
        <span className="pointer-events-none absolute right-full mr-2 hidden group-hover:flex items-center whitespace-nowrap bg-zinc-900 text-white text-xs font-semibold px-3 py-1.5 rounded shadow-lg">
          kontor@mcautotransport.dk
        </span>
      </a>

      <a
        href="https://www.facebook.com/MCautotransport/"
        target="_blank"
        rel="noopener noreferrer"
        title="Følg MC Transport på Facebook"
        className="group relative flex items-center justify-center w-12 h-12 bg-[#1877f2] hover:bg-[#0d65d9] text-white transition-colors border-t border-white/10"
      >
        <i className="fa-brands fa-facebook-f text-lg" aria-hidden="true" />
        <span className="sr-only">Besøg MC Transport på Facebook</span>
        <span className="pointer-events-none absolute right-full mr-2 hidden group-hover:flex items-center whitespace-nowrap bg-zinc-900 text-white text-xs font-semibold px-3 py-1.5 rounded shadow-lg">
          Følg os på Facebook
        </span>
      </a>
    </aside>
  );
}
